import { useTranslation } from 'react-i18next'
import { ReferenceType } from '../deposit-split.types'
import { EditAction, DeleteAction, Action } from 'src/app/components/data-grid-action-cell-item/'
import { faDivide } from '@fortawesome/pro-solid-svg-icons'
import { Stack } from '@vapor/material'

export const useReferenceDescription = () => {
  const { t } = useTranslation()

  const getPrefix = (type: ReferenceType) => {
    switch (type) {
      case 'reservation':
        return `${t('pms.accounting.documents.deposit_split.reference_type_reservation')}`
      case 'reservedResource':
        return `${t('pms.accounting.documents.deposit_split.reference_type_reservedResource')}`
      case 'bill':
        return `${t('pms.accounting.documents.deposit_split.reference_type_bill')}`
    }
  }

  const getReferenceDescription = ({ type, description }: { type: ReferenceType; description: string }) => {
    return `${getPrefix(type)}: ${description}`
  }

  return getReferenceDescription
}

export const ReferenceDescriptionCell = ({ type, description }: { type: ReferenceType; description: string }) => {
  const getReferenceDescription = useReferenceDescription()
  return <>{getReferenceDescription({ type, description })}</>
}

export const ActionsCell = ({
  showEdit,
  showSplit,
  showDelete,
  edit,
  split,
  deleteFn,
}: {
  showEdit: boolean
  showSplit: boolean
  edit?: () => void
  split?: () => void
  showDelete: boolean
  deleteFn?: () => void
}) => {
  const { t } = useTranslation()

  return (
    <Stack direction="row" spacing={1}>
      {showEdit && edit && <EditAction onClick={edit} />}
      {showSplit && split && <Action icon={faDivide} onClick={split} label={t('pms.accounting.documents.deposit_split.action_split')} showLabelInTooltip />}
      {showDelete && deleteFn && <DeleteAction onClick={deleteFn} />}
    </Stack>
  )
}
